import customerConstants from './customerConstants';

const initialState = {
  customers: [],
  searchedCustomers: [],
  isLoading: false,
  searchWord: '',
  selectedCustomer: null,
  customerLogs: [],
  selectedLogline: {},
};

export default function customersReducer(state = initialState, action) {
  switch (action.type) {
    case customerConstants.GET_CUSTOMERS_SUCCESS:
      return {
        ...state,
        customers: action.customers,
      };
    case customerConstants.GET_CUSTOMERS_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case customerConstants.SEARCH_CUSTOMERS || customerConstants.GET_LOGLINES:
      return {
        ...state,
        searchWord: action.searchWord,
        isLoading: true,
      };
    case customerConstants.SEARCH_CUSTOMERS_SUCCESS:
      return {
        ...state,
        searchedCustomers: action.customers,
        isLoading: false,
      };
    case customerConstants.SEARCH_CUSTOMERS_FAILURE ||
      customerConstants.GET_LOGLINES_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };
    case customerConstants.SET_SELECTED_USER:
      return {
        ...state,
        selectedCustomer: action.selectedCustomer,
      };
    case customerConstants.GET_LOGLINES:
      return {
        ...state,
        isLoading: true,
      };
    case customerConstants.GET_LOGLINES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        customerLogs: action.customerLogs,
      };
    case customerConstants.SET_SELECTED_LOGLINE: {
      return {
        ...state,
        selectedLogline: action.selectedLogline,
      };
    }
    default:
      return state;
  }
}
